import { SNACKBAR_COLOR } from '../utils/constants'
import { ApiStatus } from '../../api/v2/api/api_constant'

export class SnackBar {
    open: boolean
    text: string
    status: any

    constructor(open, text, status){
        this.open = open
        this.text = text
        this.status = status
    }

    get color() {
        switch (this.status) {
            case ApiStatus.SUCCESS:
                return SNACKBAR_COLOR.success
            case ApiStatus.AUTHENTION_ERROR:
            case ApiStatus.CANNOT_ANSWER:
            case ApiStatus.DELETE_ERROR:
            case ApiStatus.EXAM_STATUS_ERROR:
            case ApiStatus.NOT_EXISTS:
            case ApiStatus.PERMISSION_DENIED:
            case ApiStatus.UNKNOW_ERROR:
            case ApiStatus.VALIDATE_ERROR:
                return SNACKBAR_COLOR.error
            default:
                return SNACKBAR_COLOR.info
        }
    }
}